import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PriceTagIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PriceTagIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.1411 21.9993C12.4815 21.9993 11.8223 21.7482 11.3207 21.2466L2.75146 12.6774C2.25674 12.1826 1.98993 11.5235 1.99977 10.821L2.08543 4.6299C2.10462 3.22252 3.22255 2.10461 4.6304 2.08492L10.8211 1.99927C11.4748 2.00123 12.1915 2.26509 12.6818 2.75439L21.2437 11.3172C21.731 11.8046 21.9998 12.4524 21.9998 13.142C21.9998 13.8312 21.7315 14.4795 21.2437 14.9669L14.9669 21.2436C14.4633 21.7472 13.8022 21.9993 13.1411 21.9993ZM10.855 3.0074H10.8344L4.6442 3.09306C3.78619 3.10487 3.10539 3.78616 3.09357 4.64368L3.00792 10.8348C3.00201 11.2631 3.16397 11.6643 3.46425 11.9646L12.0335 20.5338C12.3294 20.8297 12.7227 20.9926 13.1411 20.9926H13.143C13.5625 20.9921 13.9568 20.8282 14.2541 20.5309L20.5309 14.2541C20.8282 13.9567 20.9916 13.562 20.9916 13.142C20.9916 12.7217 20.8282 12.3269 20.5309 12.03L11.969 3.46766C11.6751 3.17427 11.2705 3.0074 10.855 3.0074Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.47174 9.74102C6.22041 9.74102 5.20242 8.72302 5.20242 7.4717C5.20242 6.22038 6.22041 5.20238 7.47174 5.20238C8.72306 5.20238 9.74106 6.22038 9.74106 7.4717C9.74106 8.72302 8.72306 9.74102 7.47174 9.74102ZM7.47174 6.21054C6.77617 6.21054 6.21056 6.77615 6.21056 7.47171C6.21056 8.16727 6.77617 8.73288 7.47174 8.73288C8.1673 8.73288 8.73291 8.16727 8.73291 7.47171C8.73291 6.77615 8.1673 6.21054 7.47174 6.21054Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PriceTagIcon;
